export class BusinessError extends Error {
    public name = 'BusinessError';
    private errorCode?: string;

    constructor(message?: string, options?: ErrorOptions & { errorCode?: string }) {
        super(message, options ?? {});

        const errorCode = options?.errorCode;
        if (errorCode) {
            this.errorCode = errorCode;
        }
    }

    isErrorType = (errorCode: string) => this.errorCode === errorCode;
}
